import React, { useState, Fragment } from "react"
import Axios from "axios"

const ContactForm = props => {
  let [fname, setFname] = useState("")
  let [fnameError, setFnameError] = useState(null)
  let [lname, setLname] = useState("")
  let [email, setEmail] = useState("")
  let [emailError, setEmailError] = useState(null)
  let [message, setMessage] = useState("")
  let [mailSent, setMailSent] = useState(false)
  let [error, setError] = useState(null)

  const validateEntireForm = () => {
    let inputs = document.querySelectorAll(
      "input[type=text],input[type=email], text-area"
    )
    let fieldFailure = false
    // NOTE: if check valid is false, the field is invalid
    console.log(inputs)
    for (let input of inputs) {
      if (!input.checkValidity() && input.required) {
        fieldFailure = true
        console.log(input)
      }
      //console.log(input.checkValidity())
    }
    //console.log("finished validate function")
    return fieldFailure
  }
  const handleFormSubmit = event => {
    event.preventDefault()
    // trigger the browser to validate each field
    if (validateEntireForm()) {
      console.log("Failure")
      return
    }

    // now check for field error states
    // console.log("fnameError", fnameError, "emailError", emailError)
    // if (fnameError !== null && emailError !== null) {
    //   console.log("condition met")
    //   return
    // }
    console.log("still going")
    console.log(fname, lname, email, message)
    // loop through all fields and validate or use state to store error status for each field

    let dataToSend = {
      firstname: fname,
      lastname: lname,
      emailaddress: email,
      messagebody: message,
    }
    Axios({
      method: "post",
      url: `${API_PATH}`,
      headers: {
        "content-type": "application/json",
      },
      data: dataToSend,
    })
      .then(result => {
        console.log("in the then", result.data)
        setMailSent(result.data.sent)
      })
      .catch(error => setError(error.message))
    console.log("Error", error)
  }

  const API_PATH = "http://kwwalton.com/WIP-2020/api/contact/index.php"

  // NOTE: On each field, we update state on change, when focus moves out/blur, validate

  return (
    <div className="contact-form fade-in">
      <form
        action="#"
        noValidate
        className={mailSent ? "form-sent" : "form-not-sent"}
      >
        <div className="form-group">
          <label htmlFor="fname">Full name *</label>
          <input
            type="text"
            id="fname"
            name="firstname"
            placeholder="Your full name"
            value={fname}
            required
            onChange={e => setFname(e.target.value)}
            onBlur={e => {
              if (e.target.checkValidity()) {
                e.target.parentElement.classList.remove("has-error")
                setFnameError(null)
              }
            }}
            onInvalid={e => {
              e.target.parentElement.classList.add("has-error")
              setFnameError("Please fill out this field.")
            }}
          />
          <span className="error-message">{fnameError}</span>
        </div>
        {/* TODO: on blur for all, you can check validity, that fires the
        onInvalid event if it applies */}
        {/* <div className="form-group">
          <label htmlFor="lname">Last name</label>
          <input
            type="text"
            id="lname"
            name="lastname"
            placeholder="Your last name"
            value={lname}
            onChange={e => setLname(e.target.value)}
          />
        </div> */}
        <div className="form-group">
          <label htmlFor="email">Email address *</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Your email address..."
            value={email}
            required
            onChange={e => setEmail(e.target.value)}
            onBlur={e => {
              if (e.target.checkValidity()) {
                e.target.parentElement.classList.remove("has-error")
                setFnameError(null)
              }
            }}
            onInvalid={e => {
              e.target.parentElement.classList.add("has-error")
              setEmailError("Please fill out this field.")
            }}
          />
          <span className="error-message">{emailError}</span>
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Your message..."
            value={message}
            onChange={e => setMessage(e.target.value)}
          ></textarea>
        </div>
        <input
          type="submit"
          value="Submit"
          onClick={e => handleFormSubmit(e)}
        />
        <p>* Required field</p>
      </form>

      <div className="contact-response">
        {mailSent && (
          <Fragment>
            <p className="contact-response-head">Thank you!</p>
            <p className="contact-response-body">I appreciate your interest.</p>
          </Fragment>
        )}
      </div>
    </div>
  )
}

export default ContactForm
